import React from 'react'
import ModalLayout from '../../shared/ModalLayout'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { FaIcon } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import { TextField } from '@/ui/form/controls/TextField'
import useContractService from '@/modules/drivers/services/ContractService'
import { LoaderIcon } from '@/app/features/icons/Loader'

const CreateTemplateModal = ({ close, companyId, driverId, contractId }) => {
  const [loading, setLoading] = React.useState(false)
  const { createContractTemplate } = useContractService()
  const [name, setName] = React.useState('')
  const { t } = useLocalize()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await createContractTemplate({
        companyId: companyId,
        driverId: driverId,
        contractId: contractId,
        templateName: name,
      })
    } catch (error) {
      console.error('Error creating template:', error)
    } finally {
      setLoading(false)
      close()
    }
  }
  return (
    <ModalLayout>
      <form
        onSubmit={handleSubmit}
        onClick={(e) => {
          e.stopPropagation()
        }}
        noValidate
        className="tw-relative tw-flex tw-h-fit tw-max-h-[90vh] tw-w-full tw-max-w-[500px] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl"
      >
        {loading && (
          <div className="tw-absolute tw-grid tw-place-items-center tw-inset-0 tw-rounded-lg tw-bg-black/40">
            <LoaderIcon className="tw-animate-spin" />
          </div>
        )}
        <div className="tw-flex tw-w-full tw-items-center tw-justify-between  tw-p-4">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {t('contract.create-template')}
          </p>

          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer tw-text-content-base hover:tw-text-primary"
            onClick={() => close()}
          />
        </div>
        <div className="tw-p-4">
          <TextField
            label= {t('contract.template-name')}
            placeholder={t('contract.template-name-placeholder')}
            name="templateName"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <footer className="tw-flex tw-justify-end ">
          <button
            disabled={loading}
            type="submit"
            className={`tw-m-4 tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
          >
            {t('operation.confirm')}
          </button>
        </footer>
      </form>
    </ModalLayout>
  )
}

export default CreateTemplateModal
